import { render, staticRenderFns } from "./dateFilter.vue?vue&type=template&id=5cd44967"
import script from "./dateFilter.vue?vue&type=script&lang=js"
export * from "./dateFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports